import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getMaterials({ commit }, {
        paginate = '',
        query = '',
        shouldSavedInStore = true
    } = {}) {

        commit('GET_MATERIALS_REQUEST')

        return axios
            .get(`/materials/materials${paginate}${query}`)
            .then(response => {
                if (shouldSavedInStore) commit('GET_MATERIALS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_MATERIALS_FAILURE')
                handleApiError(error, 'Pobranie listy materiałów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getMaterial(context, materialId) {
        return axios
            .get(`/materials/materials/${materialId}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, `Pobranie danych do materiału ${materialId} nie powiodło się.`)

                return Promise.reject(error)
            })
    },
    createMaterial({ commit }, materialData) {
        return axios
            .post('/materials/materials', materialData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Materiał został dodany.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie materiału nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateMaterial({ commit }, materialData) {
        return axios
            .put(`/materials/materials/${materialData.id}`, materialData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Materiał został zedytowany.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja materiału nie powiodła się.')

                return Promise.reject(error)
            })
    },
    getUnitsOfMeasure({ commit }) {
        return axios
            .get('/materials/materials/dicts/units-of-measure')
            .then(response => {
                commit('GET_UNITS_OF_MEASURE_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie listy jednostek nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getMaterialTypes({ commit }) {
        return axios
            .get('/materials/material-types')
            .then(response => {
                commit('GET_MATERIAL_TYPES', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie typów materiałów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateMaterialType(context, materialTypeData) {
        return axios
            .patch(`/materials/material-types/${materialTypeData.id}`, materialTypeData)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja typu materiału nie powiodła się.')

                return Promise.reject(error)
            })
    },
    generateMaterialsPriceList({ commit }, {
        userEmail
    } = {}) {
        return axios
            .post('/materials/export-materials', {
                timeout: 120000, // 2 min
            })
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: `Cennik materiałów został wysłany na adres ${userEmail}.`
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie cennika nie powiodło się.')

                return Promise.reject(error)
            })
    },
    importMaterialsPriceList({ commit, state }, { formData, abort}) {
        if (!abort) {
            const cancelToken = axios.CancelToken
            const cancelTokenSource = cancelToken.source()

            commit('SET_CANCEL_TOKEN', cancelTokenSource)
        } else {
            state.cancelToken.cancel('canceled')
        }

        commit('FILE_PROGRESS', {
            show: true,
            value: 0
        }, { root: true })

        return axios
            .post('/materials/import-materials', formData, {
                cancelToken: state.cancelToken.token,
                timeout: 900000, // 15 min
                onUploadProgress(progressEvent) {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)

                    commit('FILE_PROGRESS', {
                        show: false,
                        value: percentCompleted
                    }, { root: true })
                }
            })
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Plik został wysłany.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                if (error.message !== 'canceled') {
                    handleApiError(error, 'Wysłanie pliku nie powiodło się.')

                    return Promise.reject(error)
                }
            })
            .finally(() => {
                commit('SET_CANCEL_TOKEN', null)
                commit('FILE_PROGRESS', {
                    show: false,
                    value: 0
                }, { root: true })
            })
    },
    setMaterialsFilters({ commit }, filters) {
        commit('SET_MATERIALS_FILTERS', filters)
    },
    clearMaterialsFilters({ commit }) {
        commit('CLEAR_MATERIALS_FILTERS')
    },
    getMaterialsPmsTypes({ commit }) {
        return axios
            .get('/materials/pms-types')
            .then(response => {
                commit('GET_MATERIALS_PMS_TYPES', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie listy typów PMS nie powiodło się.')

                return Promise.reject(error)
            })
    }
}